import React, { useState } from "react";
import { Button, Modal, Upload, message, Radio } from "antd";
import { Document, Page, pdfjs } from 'react-pdf';
import UserStore from "../../store/members.store";

import { UploadOutlined } from "@ant-design/icons";
import { API_URL } from "../../helper/axioscontants";

function CertificateAddModal({
  certificateModalOpen,
  setCertificateModalOpen,
  companyName,
  email,
}) {
  const [documentType, setDocumentType] = useState({
    documenttype: "",
  });
  const [documentFile, setDocumentFile] = useState(null);
  const baseURL = API_URL;
  const { updateUserDoc } = UserStore();

  const props = {
    name: "companydoc",
    action: `${baseURL}/updateCompanyDocuments/${companyName}/${email}`,
    maxCount: 1,

    data: {
      documenttype: "pdf",
      documentname: documentType,
    },
    onChange(info) {
      console.log(info, "This is info");
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        //now check if
        // 1. Resume already exists for this JD by the same user ID
        // 2. Resume already exists for this JD byt other user ID
        // 3. Resume already exist for this JD
        //response: '{"status": "success"}', // response from server
        var responseData = info.file.response;
        if (responseData.status == "DUPLICATE_UPLOADED_VENDOR") {
          message.success(
            `${info.file.name} Duplicate, Uploaded by Another Vendor`
          );
        } else if (responseData.status == "DUPLICATE_UPLOADED_INTERNAL") {
          message.success(
            `${info.file.name} Duplicate, Already Assigned to this JD`
          );
        } else {
          message.success(`${info.file.name} file uploaded successfully`);
        }
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const getUserDetails = () => {
    const userDetails = localStorage.getItem('userDetails');
    return userDetails ? JSON.parse(userDetails) : null;
  };

  const userID = getUserDetails()?.qhuid;
  const ownerID = getUserDetails()?.qhoid
;
  
  const UploadDocument = (file) => {
    console.log(documentType.documenttype, "This is document type");
    
    updateUserDoc(ownerID,userID, { document: file ,documenttype: documentType.documenttype}, (error, status) => {
      if (error) {
        message.error(`Failed to upload document: ${error}`);
      } else {
        message.success(`Document uploaded successfully: ${status}`);
      }
    });

    
  
    //  console.log('Saving document:', documentFile.document);
              message.success('Document saved successfully!');
    // Handle document upload logic here
  };

  const handleChange = (e) => {
    setDocumentType({
      documenttype: e.target.value,
    });
  };

  return (
    <Modal
      title="Upload Certificate"
      open={certificateModalOpen}
      footer={null}
      onCancel={() => setCertificateModalOpen(false)}
    >
      <Radio.Group
        className="profile-radio-wrapper"
        onChange={handleChange}
        name="documenttype"
        style={{ marginTop: "20px", marginBottom: "30px" }}
      >
        <Radio className="radio-option" value="registration-doc">
          Registration Certificates
        </Radio>
        <Radio className="radio-option" value="tax-certificate">
          GST/TAX Certificates
        </Radio>
      </Radio.Group>

       <Upload
          beforeUpload={(file) => {
          const isPdf = file.type === 'application/pdf';
          if (!isPdf) {
            message.error('You can only upload PDF files!');
            return false;
          }
          // Store the file for multipart/form-data
          // Convert file to binary and store it
          // Store the file directly for FormData submission
          //setFormData(prev => ({ ...prev, document: file }));
      
          // setFormData(prev => ({ ...prev, document: data }));
          setDocumentFile(prev => ({
            ...prev,
            document: file,
            currentPage: 1
          }));
          return false; // Prevent auto upload
          }}
          showUploadList={true}
          accept=".pdf"
          maxCount={1}
          >
          <Button style={{ width: "100%", height: "40px", fontWeight: "600" }}>
          Upload Document
          </Button>
          </Upload>
          
          <Button 
            type="primary"
            disabled={!documentFile?.document}
            style={{ 
              width: "100%", 
              height: "40px", 
              fontWeight: "600",
              marginTop: "10px"
            }}
            onClick={() => { UploadDocument(documentFile.document) }}
          >
            Save Document
          </Button>
          
          {documentFile?.document && (
            <div className="document-viewer" style={{ marginTop: "15px", border: "1px solid #d9d9d9", borderRadius: "6px", padding: "16px" }}>
            <h4>Document Preview:</h4>
            <Document
            file={documentFile.document}
            onLoadSuccess={({ numPages }) => {
            console.log(`Loaded ${numPages} pages`);
            setDocumentFile(prev => ({ ...prev, totalPages: numPages }));
            }}
            onLoadError={(error) => console.error('Error loading PDF:', error)}
            >
            <Page 
            pageNumber={documentFile.currentPage || 1} 
            width={400}
            style={{ marginBottom: '10px' }}
            />
            </Document>
            {documentFile.totalPages > 1 && (
            <div style={{ textAlign: 'center', marginTop: '10px' }}>
                    <Button 
                      disabled={documentFile.currentPage <= 1}
                      onClick={() => setDocumentFile(prev => ({ ...prev, currentPage: prev.currentPage - 1 }))}
                      style={{ marginRight: '10px' }}
                    >
                      Previous
                    </Button>
                    <span>Page {documentFile.currentPage || 1} of {documentFile.totalPages}</span>
                    <Button 
                      disabled={documentFile.currentPage >= documentFile.totalPages}
                      onClick={() => setDocumentFile(prev => ({ ...prev, currentPage: prev.currentPage + 1 }))}
                      style={{ marginLeft: '10px' }}
                    >
                      Next
                    </Button>
            </div>
            )}
          </div>
        )}
    </Modal>
  );
}

export default CertificateAddModal;
